import { memo } from "react";

import { cn } from "@/lib/utils";

import type { IGlobalSearchKbdProps } from "./types";

// NOTE: NSAI-6853 — one keycap, as the palette footer and the header trigger
// draw it: a quiet outlined chip that sits on glass and on the page alike.
const GlobalSearchKbdComponent = ({
  children,
  className,
}: IGlobalSearchKbdProps): JSX.Element => (
  <kbd
    className={cn(
      "inline-flex h-5 min-w-5 items-center justify-center rounded-md border border-glass-edge bg-glass-fill px-1.5 font-sans text-[11px] font-medium leading-none text-foreground-secondary shadow-[inset_0_-1px_0_var(--glass-fill-strong)]",
      className,
    )}
  >
    {children}
  </kbd>
);

export const GlobalSearchKbd = memo(GlobalSearchKbdComponent);
